export default "__VITE_ASSET__BHNAFmJ8__"